import React from "react";
import { createContext, useContext, useMemo } from "react";
import LoadingLogo from "./LoadingLogo";

// Create a context for our custom spinner
export const SpinnerContext = createContext<React.FC<any> | null>(null);

// Hook to use our custom spinner
export const useCustomSpinner = () => {
  const CustomSpinner = useContext(SpinnerContext);
  return CustomSpinner || LoadingLogo;
};

// Custom provider component
interface SpinnerProviderProps {
  children: React.ReactNode;
}

// This provider overrides the default Chakra UI Spinner with our custom LoadingLogo
export const SpinnerProvider: React.FC<SpinnerProviderProps> = ({
  children,
}) => {
  // Ensure we have our LoadingLogo as the custom spinner
  const customSpinner = useMemo(() => LoadingLogo, []);

  return (
    <SpinnerContext.Provider value={customSpinner}>
      {children}
    </SpinnerContext.Provider>
  );
};

export default SpinnerProvider;
